import ListItem from "@mui/material/ListItem";
import { librarySelectedTab, setSelectedLeftNav } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { clearFilters } from "components/common/Filters/Filters.slice";
import Typography from "components/common/Typography";
import { resetAllFilters } from "components/features/AboveProperty/AboveProperty.slice";
import { resetMyListsData, resetSorting, setRecentlyViewed } from "components/features/Corp/CorpUser.Slice";
import { setSelectedAdminInncodes } from "components/features/MyPlans/myplans.slice";
import { resetConfigTabSelected } from "components/features/dashboard/Dashboard.slice";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { leftNavItems } from "utils/Types";

interface Props {
  label: string;
  link: string;
  Icon: any;
  paths?: any;
}

function Item(props: Props) {
  const { link, label, Icon, paths } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const savedFiltersAndLists = useAppSelector((state) => state.filters.savedFilter);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);

  const getSelectedTab = () => {
    if (paths.includes(location.pathname.split("/")[1])) dispatch(setSelectedLeftNav(label));
    return paths.includes(location.pathname.split("/")[1]);
  };

  return (
    <ListItem
      sx={{
        color: `${tokens.Text.General.Secondary}`,
        display: "flex",
        flexDirection: isMobileScreen ? "row" : "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "7px",
        marginTop: "12px",
        cursor: "pointer",
        minHeight: isMobileScreen ? "30px" : "74px",
        borderRadius: "10px",
        "&.Mui-selected": {
          backgroundColor: tokens.Background.General.Color,
          color: `${tokens.Text.General.Color}`
        },
        ":hover": {
          backgroundColor: (theme) => theme.palette.secondary.main
        }
      }}
      selected={getSelectedTab()}
      onClick={() => {
        dispatch(resetAllFilters());
        dispatch(setSelectedAdminInncodes([]));
        dispatch(librarySelectedTab(0));
        dispatch(resetConfigTabSelected({}));
        if (link !== location.pathname && isAdmin) dispatch(clearFilters({}));
        if (label !== "My Lists" && isAdmin) {
          dispatch(resetMyListsData(savedFiltersAndLists["bookmarked"]?.[0]));
        }
        if (label === leftNavItems.myLists && isAdmin) {
          dispatch(
            resetSorting({
              type: "myList"
            })
          );
        }
        if (isAdmin) dispatch(setRecentlyViewed(""));
        if (label === leftNavItems.corporateDashboard && isAdmin)
          dispatch(
            resetSorting({
              type: "dashboard"
            })
          );

        if (label === "Inncode Plans" || label === "My Plans")
          navigate(link, {
            state: {
              backButtonVisible: false
            }
          });
        else if (label === "My Lists")
          navigate(link, {
            state: {
              toggleOpen: isMobileScreen,
              backButtonVisible: false
            }
          });
        else navigate(link);
      }}
    >
      {paths.includes(location.pathname.split("/")[1]) ? (
        <Icon stroke={tokens.Icon.General.Color} />
      ) : (
        <Icon stroke={tokens.Icon.General.Secondary} />
      )}
      <Typography
        variant={isMobileScreen ? "h4" : "label"}
        changeVariant={false}
        sx={{ marginLeft: isMobileScreen ? "5px" : 0, textAlign: "center" }}
      >
        {label}
      </Typography>
    </ListItem>
  );
}

export default Item;
